import { Page, PageTabed, PageTable } from '@components-common/layouts';
import { AssignmentForm } from '@components-domain/education';
import {
  ConfigSection,
  CreateTemplate,
  EditTemplate,
} from '../../components-fabric';
import { layoutCourse } from '../_common/layout.course';
import { layoutWorkspace } from '../_common/layout.workspace';
import { PageFormToolbar } from '../../components-common/layout/views/PageFormToolbar';
import { clone } from 'ramda';
import { getAssignmentValidationSchema } from '../../components-domain/education-domain/assignments/schema';
import { IndexContainer } from '../../components-common/containers/IndexContainer';
import { application } from '../../_runtime/bootstrap';
import { ConfigurationForm } from '../../components-domain/generation-domain/configurations/wizard/ConfigurationForm';
import { AddStudentToAssignment } from '../../components-domain/education-domain/assignments/AddStudentToAssignment';
import { DiStellarViewer } from '../../areas/distellar/DiStellarViewer';
import { downloadFile } from '../../components-common/_shared/actionButton.helper';
import { getResourcesValidationSchema } from '../../components-domain/education-domain/courses/resources.schema';
import { ResourcesForm } from '../../components-domain/education-domain/courses/ResourcesForm';
import { addDaysToDate } from '../_helper.functions';
import { JsonViewer } from '../../components-domain/generation-domain/specifications';
import { GroupColumn } from './_customCollumns';

export const assignmentsRoutesShared = {
  columns: [
    'courseLogo',
    'title',
    GroupColumn,
    'description',
    'state',
    'startDate',
    'endDate',
  ],
  source: (role: string) => {
    if(role === 'STUDENT') return `/coursesms/assignments/self`;
    return `coursesms/assignments`;
  },
  layout: layoutCourse,
  form: AssignmentForm,
  empty: {
    title: '',
    description: '',
    state: 'ACTIVE',
    groupId: null,
    startDate: addDaysToDate(new Date(Date.now()), 1),
    endDate: addDaysToDate(new Date(Date.now()), 2),
    picture: {
      url: '',
    },
    contents: '',
    fileName: '',
  },
  endpoints: `coursesms/assignments`,
};

const formScreen = {
  Component: PageFormToolbar,
  form: AssignmentForm,
  template: `coursesms/assignments`,
  schema: getAssignmentValidationSchema(),
  empty: assignmentsRoutesShared.empty,
};

const assignmentTabs = [
  {
    id: 'assignment_students',
    title: 'Students',
    components: [
      {
        Component: IndexContainer,
        props: {
          toolbar: {
            id: 'table_people',
            cat: 'toolbar',
            type: 'index',
            left: [
              {
                kind: 'open_modal',
                label: 'Add students',
                actionToDispatch: {
                  action: 'open_modal',
                  payload: {
                    Component: AddStudentToAssignment,
                    show: true,
                  },
                },
              },
            ],
          },
          table: {
            cat: 'table',
            type: 'editor',
            id: 'table_people',
            props: {
              source: {
                type: 'REMOTE',
                url: '/coursesms/assignments/members/students',
                key: '/coursesms/assignments/members/students',
                urlParams: { assignmentId: '{assignmentId}' },
              },
              columns: [
                { id: 'name', dataField: 'user.displayName' },
                { id: 'email', dataField: 'user.email' },
                { id: 'role', dataField: 'user.role' },
                { id: 'state' },
              ],
              actions: [
                {
                  id: 'delete',
                  roles: ['STUDY_DIRECTOR', 'LECTURER'],
                  actionToDispatch: {
                    payload: {
                      endpointToDelete: '/coursesms/assignments/members',
                    },
                  },
                  displayTooltip: true,
                  tooltipText: 'Delete user',
                },
              ],
            },
          },
        },
      },
    ],
  },
  {
    id: 'assignment_resources',
    title: 'Resources',
    components: [
      {
        Component: IndexContainer,
        props: {
          toolbar: {
            id: 'tlb_resources',
            cat: 'toolbar',
            type: 'index',
            left: [
              {
                id: 'create',
                kind: 'create',
                onAction: (props: any) => props.navigate('resources/new'),
              } as any,
            ],
          },
          table: {
            cat: 'table',
            type: 'editor',
            id: 'tlb_resources',
            props: {
              source: {
                type: 'REMOTE',
                url: '/mediasms/mediaitemresources',
                key: '/mediasms/mediaitemresources',
                urlParams: { subjectId: '{assignmentId}', courseId: "{id}" },
              },
              columns: [
                { id: 'name', dataField: 'name' },
                'description',
                'type',
                'createdDate',
                { id: 'fileExtension', text: 'Type' },
              ],
              actions: [
                {
                  id: 'download',
                  onClick: (props: any) =>
                    downloadFile(props.row.url, props.row.fileName),
                  displayTooltip: true,
                  tooltipText: 'Download resource',
                },
                {
                  id: 'delete',
                  roles: ['STUDY_DIRECTOR', 'LECTURER'],
                  actionToDispatch: {
                    payload: {
                      endpointToDelete: '/mediasms/mediaitemresources',
                    },
                  },
                  displayTooltip: true,
                  tooltipText: 'Delete resource',
                },
              ],
            },
          },
        },
      },
    ],
  },
  {
    id: 'assignment_submissions',
    title: 'Submissions',
    components: [
      {
        Component: IndexContainer,
        props: {
          toolbar: {
            id: 'table_submissions',
            cat: 'toolbar',
            type: 'index',
            left: [],
          },
          table: {
            cat: 'table',
            type: 'editor',
            id: 'table_submissions',
            props: {
              source: {
                type: 'REMOTE',
                url: '/coursesms/assignments/submissions/summary',
                key: '/coursesms/assignments/submissions/summary',
                urlParams: { assignmentId: '{assignmentId}' },
              },
              columns: [
                {
                  id: 'name',
                  sort: false,
                  text: 'Configuration Name',
                  dataField: 'configuration.name',
                },
                { id: 'email', text: 'Student Email', dataField: 'user.email' },
                'createdDate',
              ],
              actions: [
                {
                  id: 'view',
                  onClick: (props: any) =>
                    props.navigate(
                      `specification/${props.row.userId}/${props.row.buildingConfigurationId}`
                    ),
                  displayTooltip: true,
                  tooltipText: 'View specification',
                },
                {
                  id: 'threeD_model',
                  onClick: (props: any) => {
                    props.navigate(`viewer/${props.row.id}`);
                  },
                  displayTooltip: true,
                  tooltipText: 'View 3D model',
                } as any,
              ],
            },
          },
        },
      },
    ],
  },
  {
    id: 'assignment_building_config',
    title: 'Building Configurations',
    components: [
      {
        Component: IndexContainer,
        props: {
          toolbar: {
            id: 'tlb_building_config',
            cat: 'toolbar',
            type: 'index',
            left: [
              {
                id: 'create',
                kind: 'create',
                onAction: (props: any) => props.navigate('new-building-config'),
              } as any,
            ],
          },
          table: {
            cat: 'table',
            type: 'editor',
            id: 'tlb_building_config',
            props: {
              source: {
                type: 'REMOTE',
                url: '/buildingsconfigms/configurations',
                key: '/buildingsconfigms/configurations',
                urlParams: { subjectId: '{assignmentId}' },
              },
              columns: [
                { id: 'name' },
                { id: 'description' },
                { id: 'createdDate' },
                { id: 'modifiedDate' },
              ],
              actions: [
                {
                  id: 'review',
                  onClick: (props: any) => {
                    props.navigate(`/building-configurations/review/${props.row.id}`);
                  },
                  displayTooltip: true,
                  tooltipText: 'Review configuration',
                },
                {
                  id: 'delete',
                  onClick: (props: any) => {
                    try {
                      application
                        .getHttpClient()
                        .delete(
                          `/buildingsconfigms/configurations/${props.row.id}`
                        )
                        .then(() => {
                          props.tableContext.refetch();
                        });
                    } catch (e) {
                      console.error(e);
                    }
                  },
                  displayTooltip: true,
                  tooltipText: 'Delete configuration',
                },
              ],
            },
          },
        },
      },
    ],
  },
];

export const courseAssignmentsScreens: ConfigSection = {
  id: 'course_assignments',
  title: 'Assignments',
  path: 'assignments',
  layout: layoutWorkspace,
  screens: [
    {
      id: 'index',
      path: '',
      roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
      Component: PageTable,
      urlParams: {
        courseId: '{id}',
      },
      source: assignmentsRoutesShared.source,
      tmp: 'index',
      columns: assignmentsRoutesShared.columns,
      left: [
        {
          id: 'create_new',
          kind: 'create_new',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
        } as any,
      ],
      actions: [
        {
          id: 'view',
          onClick: (props: any) => {
            if (props.userRole === 'STUDENT')
              props.navigate(`/assignments/${props.row.courseId}/${props.row.id}`);
            else props.navigate(`${props.row.id}`);
          },
          displayTooltip: true,
          tooltipText: 'View assignment',
        },
        {
          id: 'copy',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          actionToDispatch: {
            payload: {
              copy: '/coursesms/assignments/assignmentClone',
            },
          },
          displayTooltip: true,
          tooltipText: 'Duplicate assignment',
        } as any,
        {
          id: 'edit',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          actionToDispatch: { payload: { path: 'edit' } },
          displayTooltip: true,
          tooltipText: 'Edit assignment',
        } as any,
        {
          id: 'delete',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          actionToDispatch: {
            payload: {
              endpointToDelete: assignmentsRoutesShared.source("LECTURER"),
            },
          },
          displayTooltip: true,
          tooltipText: 'Delete assignment',
        },
      ],
    } as any,
    {
      ...clone(formScreen),
      left: ['create'],
      id: 'create',
      path: '/new',
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      tmp: 'create',
    } as CreateTemplate,
    {
      ...clone(formScreen),
      left: ['save'],
      right: ['back'],
      id: 'edit',
      path: ':assignmentId/edit',
      editSource: `coursesms/assignments/`,
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      idPropSource: 'assignmentId',
      tmp: 'edit',
    } as EditTemplate,
  ],
  sections: [
    {
      id: 'assignment',
      tmp: 'tabbed',
      path: ':assignmentId',
      layout: layoutWorkspace,
      Component: PageTabed,
      screens: [
        {
          id: 'assignment_tabs',
          path: '',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          tabs: assignmentTabs,
        },
        {
          id: 'building_config_assignment',
          path: 'new-building-config',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          Component: Page,
          tmp: 'custom',
          children: [
            {
              Component: ConfigurationForm,
              type: 'create',
              cat: 'form',
              props: {
                isInCourseAssignment: true,
              },
            },
          ],
        },
        {
          id: 'submission_distellar_view',
          path: 'viewer/:submissionId',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          tmp: 'custom',
          layout: layoutWorkspace,
          children: [
            {
              Component: DiStellarViewer,
              cat: 'page',
              type: 'index',
              layout: layoutWorkspace,
              props: {
                isInCourseAssignment: true,
              },
            },
          ],
        },
        {
          id: 'review_submission_specification',
          title: 'Review Submission',
          path: 'specification/:userId/:buildingConfigurationId',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          tmp: 'custom',
          Component: JsonViewer,
        },
        {
          id: 'create',
          path: 'resources/new',
          tmp: 'create',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          left: ['create'],
          schema: getResourcesValidationSchema(),
          Component: PageFormToolbar,
          form: ResourcesForm,
          empty: {
            name: '',
            subjectId: '',
            fileName: '',
            contents: '',
          },
        } as CreateTemplate,
      ],
    },
  ] as any,
};
